import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageVitoria = props => {
  return <CityLandingPage cityKey="Vitoria" cityConfig={cityContent.vitoria} {...props} />;
};

export default LandingPageVitoria;
